export default __webpack_public_path__ + "static/media/matkaWheelBg.a1933910.svg";